/**
 * Warning icon and message shown in the desktop future-dates modal (`FutureDatesDesktop.tsx`) for
 * a customer-part line whose delivery date is TBD.
 */
import React from "react";
import { Flex } from "@ryerson/frontend.layout";
import { useTheme } from "@ryerson/frontend.theme";
import { Typography } from "@ryerson/frontend.typography";
import { Icon } from "@ryerson/frontend.assets";

interface CustomerTBDItemWarningMessageProps {
	/** True adds 40px above (caller puts it under the table); false adds 40px below (above it). */
	hasMultipleDeliveryDates: boolean | undefined;
	message: string;
}

/** Customer-part TBD warning; spacing follows its position relative to the ship-dates table. */
export const CustomerTBDItemWarningMessage: React.FC<CustomerTBDItemWarningMessageProps> = ({
	hasMultipleDeliveryDates,
	message,
}) => {
	const { theme } = useTheme();
	const { darkGray } = theme.colors.primary;
	return (
		<Flex css={{ gap: "10px", marginTop: hasMultipleDeliveryDates ? 40 : 0 }}>
			<Icon icon={"warning"} size="md" />
			<Typography
				css={{ marginBottom: !hasMultipleDeliveryDates ? 40 : 0, width: "fit-content" }}
				color={darkGray}
			>
				{message}
			</Typography>
		</Flex>
	);
};
